import Swiper from "swiper";
import { Autoplay, EffectFade, Pagination } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
	// if the class .hero-slider exists
	if (document.querySelector(".hero-slider")) {
		// Add .swiper-wrapper class to the .acf-innerblocks-container inside .hero-slider
		const heroSlider = document.querySelector(".hero-slider");
		const innerBlocksContainer = heroSlider.querySelector(
			".acf-innerblocks-container"
		);
		if (innerBlocksContainer) {
			innerBlocksContainer.classList.add("swiper-wrapper");
		}

		// Initialize Swiper
		const swiper = new Swiper(".hero-slider", {
			modules: [EffectFade, Autoplay, Pagination],
			effect: "fade",
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			speed: 1000,
			loop: true,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
		});
	}

	// Scrolling Content Panel Block
	const images = document.querySelectorAll(".spy-img");
	const panelImageMap = [];

	images.forEach((image) => {
		const panelId = image.getAttribute("data-bs-target");
		const panel = document.querySelector(panelId);

		if (panel) {
			panelImageMap.push({ panel, image });
		}
	});

	function updateActiveImage() {
		let closest = null;
		let closestDistance = Infinity;
		const viewportCenter = window.innerHeight / 2;

		panelImageMap.forEach(({ panel, image }) => {
			const rect = panel.getBoundingClientRect();
			const panelCenter = rect.top + rect.height / 2;
			const distance = Math.abs(panelCenter - viewportCenter);

			if (distance < closestDistance) {
				closest = image;
				closestDistance = distance;
			}
		});

		// Remove .active from all images, then add it to the closest one
		images.forEach((img) => img.classList.remove("active"));
		if (closest) closest.classList.add("active");
	}

	// Run on scroll and on load
	window.addEventListener("scroll", updateActiveImage);
	window.addEventListener("resize", updateActiveImage);
	window.addEventListener("load", updateActiveImage);
});

// jQuery specifc code
jQuery(function ($) {
	// When window is loaded, move #mega-menu as a child of .mega-menu-btn

	$(window).on("load", function () {
		// Check if the element exists before trying to move it
		if ($("#mega-menu").length) {
			$("#mega-menu").detach().appendTo(".mega-menu-btn");
		}
	});

	// When clicking on the mega menu button, toggle the mega menu by adding .active to .mega-menu-btn
	$(".mega-menu-btn").on("click", function () {
		$(this).toggleClass("active");
	});

	// When clicking outside the #mega-menu, remove the .active class from .mega-menu-btn
	// Prevent closing the menu when clicking on the background
	$("#mega-menu").on("click", function (e) {
		e.stopPropagation();
	});

	$(document).on("click", function (e) {
		const isClickInsideMenu =
			$(e.target).closest(".mega-menu-btn").length > 0 ||
			$(e.target).closest("#mega-menu").length > 0;
		if (!isClickInsideMenu) {
			$(".mega-menu-btn").removeClass("active");
		}
	});

	// Channel Line up table Search

	$("#channel-input").on("keyup", function () {
		var value = $(this).val().toLowerCase();

		$("table.channel-table tbody tr").filter(function () {
			$(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
		});
	});

	// Channel line up column search
	$("#channellineup thead tr th").on("click", function () {
		let th_name = $(this).text().toLowerCase();

		if ($(this).index() != 0 && $(this).index() != 1 && $(this).index() != 6) {
			$("#channellineup table.channel-table tbody tr").filter(function () {
				$(this).toggle($(this).text().toLowerCase().indexOf(th_name) > -1);
			});
		} else if ($(this).index() === 6) {
			th_name = "hd";
			$("#channellineup table.channel-table tbody tr").filter(function () {
				$(this).toggle($(this).text().toLowerCase().indexOf(th_name) > -1);
			});
		} else if ($(this).index() === 0) {
			$("#channellineup table.channel-table tbody tr").filter(function () {
				$(this).toggle($(this).text().toLowerCase().indexOf("") > -1);
			});

			var sorted = $("#channellineup table.channel-table tbody tr").sort(
				function (a, b) {
					var a = $(a).find("td:first").text(),
						b = $(b).find("td:first").text();
					return a.localeCompare(b, false, { numeric: true });
				}
			);
			$("#channellineup table.channel-table tbody").html(sorted);
		} else {
			$("#channellineup table.channel-table tbody tr").filter(function () {
				$(this).toggle($(this).text().toLowerCase().indexOf("") > -1);
			});
		}
	});

	// console.log($(window).width());

	// $(window).resize(function () {
	if ($(window).width() < 1420) {
		$("table.channel-table tbody tr td").each(function () {
			if ($(this).text() == "HD" || $(this).text() == "SD") {
				$(this).css({
					position: "absolute",
					right: "0",
				});
			}
		});
	}
	// });

	// Channel lineup Icon Hover
	$("#channellineup table tbody tr td img").hover(
		function () {
			$(this).next().next().fadeOut(100);
			$(this).next().next().fadeIn(500);
		},
		function () {
			$(this).next().next().fadeOut(100);
		}
	);

	// Mobile Travel Drop-down
	$("#countrySelect").on("change", function () {
		let countryName = this.value;
		// alert(countryName);

		$.ajax({
			type: "POST",
			url: "/wp-admin/admin-ajax.php",
			dataType: "json",
			data: {
				action: "filterProducts", // the action has to be the same name as the function on the server(php) side
				country: countryName,
			},
			success: function success(response) {
				//Replace the products with the newly filtered products
				$("#travelAddOns").html(response.data[0]);

				// $("html, body").animate(
				//   {
				//     scrollTop: $(window).offset(811).top,
				//   },
				//   500
				// );

				// Travel Plans - Does not show tab if it has no plans
				$("#travel-add-ons ul > li").each(function () {
					// Data-bs-target of each sub tabs
					let travel_tab_id = $(this)
						.children()[0]
						.attributes[3].nodeValue.replace("#", "");
					// console.log(travel_tab_id);

					$("#travel-add-ons #pills-tabContent .tab-pane").each(function () {
						console.log("hello", $(this).find(travel_tab_id));
					});
				});

				if (countryName != "") {
					$(window).scrollTop(680);
				}
			},
			error: function error(response) {
				console.error(response);
			},
		});
	});

	// Travel United STates
	$(".us-travel-addons-btn a").on("click", function () {
		let countryName = "United States";

		// Make the countrySelect field selected to United States
		$("#countrySelect").val("united-states");

		$.ajax({
			type: "POST",
			url: "/wp-admin/admin-ajax.php",
			dataType: "json",
			data: {
				action: "filterProducts", // the action has to be the same name as the function on the server(php) side
				country: countryName,
			},
			success: function success(response) {
				//Replace the products with the newly filtered products
				$("#travelAddOns").html(response.data[0]);
				// console.log(response.result);

				// Scroll to the #travelAddOns section only after the content is loaded
				// Wait for the DOM to update with the new content before scrolling
				setTimeout(function () {
					$("html, body").animate(
						{
							scrollTop: $("#travelAddOns").offset().top - 200,
						},
						500
					);
				}, 50);
			},
			error: function error(response) {
				console.error(response);
			},
		});
	});
});
